import {module} from 'modujs';
import {html} from '../utils/environment';
import { detect } from 'detect-browser';

export default class extends module {
    constructor(m) {
        super(m);

        this.messages = JSON.parse(this.getData('messages'));
    }

    init() {
        this.prepareMessage();
    }

    prepareMessage() {
        if (!this.el) {
            return;
        }

        const detectedBrowser = detect();

        const browser = ['chrome', 'firefox', 'edge', 'safari'].includes(detectedBrowser.name)
            ? detectedBrowser.name
            : null;

        if (browser && this.messages[browser]) {
            this.setMessage(this.messages[browser]);
        } else if (this.messages['default']) {
            this.setMessage(this.messages['default']);
        }
    }

    setMessage(message) {
        if (typeof message === 'string' && message.length) {
            this.el.innerHTML = message;
            return;
        }

        if (typeof message.value === 'string' && message.value.length) {
            if (message.locale && message.locale !== html.lang) {
                this.el.lang = message.locale;

                if (message.direction) {
                    this.el.dir = message.direction;
                }
            }

            this.el.innerHTML = message.value;
            return;
        }
    }
}
